import { Timeplan } from './timeplan';

export const TIMEPLANS: Timeplan[] = [
  {
    period: '',
    category: 'incremental',
    objective: ['']
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/timeplans/timeplans.ts